import { useEffect } from 'react';

import envs from 'envs';

export default function useClarity() {
  // Initialize Microsoft Clarity
  useEffect(() => {
    if (!window.clarity) {
      // eslint-disable-next-line func-names
      window.clarity = function () {
        // eslint-disable-next-line prefer-rest-params
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      const script = document.createElement('script');
      script.async = 1;
      script.src = `https://www.clarity.ms/tag/${envs.CLARITY_PROJECT_ID}`;
      document.head.appendChild(script);
    }
  }, []);
}
